import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import {
  Button,
  Close,
  // DatePicker,
  TextField,
  TypableDropdown,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import AutocompleteWithCheckBoxes from '../../atoms/Autocomplete';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { monthOptions } from '../../../core-utils/helper-utils/experienceHelper';

export interface AddGroupPopupProps {
  open: boolean;
  handleSave: () => void;
  handleStartOnBoarding: () => void;
  handleClose: () => void;
  groupValue: string;
  setGroupValue: React.Dispatch<React.SetStateAction<string>>;
  fieldsData: any;
  setFieldsData: React.Dispatch<any>;
  options: string[];
  values: string[];
  isEdit?: boolean;
  hideGroupTextField?: boolean;
}

const useStyles = makeStyles()({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  root: {
    width: '665px',
    height: '580px',
    borderRadius: '4px',
    background: patientAccessTheme.palette.status.white,
    borderBottom: '1px solid' + patientAccessTheme.palette.grey[300],
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 32px 20px 32px',
    borderBottom: '1px solid' + patientAccessTheme.palette.grey[300],
  },
  body: {
    padding: '20px 28px',
  },
  groupName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px',
    borderRadius: '8px',
    padding: '28px 25px',
    border: '1px solid' + patientAccessTheme.palette.grey[300],
    marginBottom: '20px',
  },
  textfieldsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    borderRadius: '8px',
    padding: '28px 25px 28px 0px',
    border: '1px solid' + patientAccessTheme.palette.grey[300],
  },
  textfield: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  buttonsGrid: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'flex-end',
    marginTop: '36px',
  },
  dropdownMenu: {
    maxHeight: '272px',
    width: '379px',
    // marginTop: '36px',
    boxShadow: '0px 2px 4px 0px #0000000D',
    border: '1px solid' + patientAccessTheme.palette.grey[300],
    ...scrollBarStyles,
  },
});

const AddGroupPopup: React.FC<AddGroupPopupProps> = ({
  open,
  handleSave,
  handleStartOnBoarding,
  handleClose,
  groupValue,
  setGroupValue,
  fieldsData,
  setFieldsData,
  options,
  values,
  isEdit,
  hideGroupTextField,
}) => {
  const { classes } = useStyles();
  const messages = componentConstants.ORGANISMS.ADD_GROUP_POPUP;
  const US_STATES = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ];

  const handleInputChange = (event: any, fieldName: string) => {
    const value = event.target.value;

    setFieldsData((prevState: any) => ({
      ...prevState,
      [fieldName]: value,
    }));
  };

  // const handleDateChange = (date: string, fieldName: string) => {
  //   setFieldsData((prevState: any) => ({
  //     ...prevState,
  //     [fieldName]: date,
  //   }));
  // };

  const handleAutoCompleteChange = (value: any, fieldName: string) => {
    setFieldsData((prevState: any) => ({
      ...prevState,
      [fieldName]: value,
    }));
  };

  return (
    <Modal open={open} className={classes.modal}>
      <Grid className={classes.root}>
        <Grid className={classes.header}>
          <Typography
            fontSize="16px"
            fontType="semiBold"
            lineHeight="22.4px"
            textColor={patientAccessTheme.palette.text.highemphasis}
          >
            {messages.TITLE}
          </Typography>
          <Close
            height={'24px'}
            width={'24px'}
            onClick={handleClose}
            cursor={'pointer'}
          />
        </Grid>
        <Grid className={classes.body}>
          <Grid className={classes.groupName}>
            <Typography
              fontSize="14px"
              fontType="regular"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.highemphasis}
            >
              {messages.GROUP_FIELD}
            </Typography>
            <TypableDropdown
              dropDownOptions={options}
              dropDownValues={values}
              placeholder={messages.GROUP_LABEL}
              value={groupValue}
              handleChange={(event) => {
                const value = event?.target?.value as string;
                setGroupValue(value);
              }}
              handleInputChange={(value) => setGroupValue(value)}
              disabled={isEdit}
              textFieldPlaceholder="Enter group name here (or) select from below"
              height="36px"
              width="379px"
              hideTextField={hideGroupTextField}
              searchable
            />
          </Grid>
          <Grid className={classes.textfieldsGrid}>
            {/* {messages.TEXT_FIELDS?.map((item, index: number) => {
              return (
                <Grid className={classes.textfield} key={`key-${index}`}>
                  <Typography
                    fontSize="14px"
                    fontType="regular"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {item}
                  </Typography>
                  <TextField
                    width="379px"
                    height="36px"
                    placeholder={`Type ${item}`}
                    value={fieldsData[item]}
                    onChange={(event: any) => handleInputChange(event, item)}
                  />
                </Grid>
              );
            })} */}
            <Grid className={classes.textfield}>
              <Typography
                fontSize="14px"
                fontType="regular"
                lineHeight="24px"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {'Plan Funding Type'}
              </Typography>
              <TypableDropdown
                dropDownOptions={[
                  'Self Funded',
                  'Fully Funded',
                  'Level Funded',
                ]}
                dropDownValues={['Self Funded', 'Fully Funded', 'Level Funded']}
                placeholder={'Select Funding Type'}
                value={fieldsData['funding_type']}
                handleChange={(event) =>
                  handleInputChange(event, 'funding_type')
                }
                handleInputChange={() => {}}
                height="36px"
                width="379px"
                hideTextField={true}
              />
            </Grid>
            <Grid className={classes.textfield}>
              <Typography
                fontSize="14px"
                fontType="regular"
                lineHeight="24px"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {'Employee Count'}
              </Typography>
              <TextField
                width="379px"
                height="36px"
                placeholder={'Enter number'}
                type="number"
                value={fieldsData['employee_count']}
                onChange={(event: any) =>
                  handleInputChange(event, 'employee_count')
                }
              />
            </Grid>
            {/* <Grid className={classes.textfield}>
              <Typography
                fontSize="14px"
                fontType="regular"
                lineHeight="24px"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {'Renewal Date'}
              </Typography>
              <DatePicker
                selectedDate={fieldsData['renewal_date'] ?? ''}
                handleChange={(date, value) =>
                  handleDateChange(value as string, 'renewal_date')
                }
                height="40px"
                width="379px"
                minDate={undefined}
                maxDate={undefined}
                format="MM-dd-yyyy"
                placeholder="mm-dd-yyyy"
              />
            </Grid> */}
            <Grid className={classes.textfield}>
              <Typography
                fontSize="14px"
                fontType="regular"
                lineHeight="24px"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {'Renewal Month'}
              </Typography>
              <Dropdown
                name="renewal_month"
                label="Select Renewal Month"
                placeholder="Select Renewal Month"
                value={fieldsData['renewal_month']}
                dropDownOptions={monthOptions}
                dropDownValues={monthOptions}
                width="380px"
                onChange={(event: any) =>
                  handleInputChange(event, 'renewal_month')
                }
                selectStyles={{
                  width: '380px',
                }}
              />
            </Grid>

            <Grid className={classes.textfield}>
              <Typography
                fontSize="14px"
                fontType="regular"
                lineHeight="24px"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {'Location'}
              </Typography>
              <AutocompleteWithCheckBoxes
                options={US_STATES}
                defaultValue={fieldsData['states']}
                handleChange={(event: any, value: any) =>
                  handleAutoCompleteChange(value, 'states')
                }
                width="379px"
                placeholder={
                  fieldsData['states']?.length === 0 ? 'Select States' : ''
                }
              />
            </Grid>
          </Grid>
          <Grid className={classes.buttonsGrid}>
            {!isEdit && (
              <Button
                label={messages.SAVE_BUTTON}
                variant="outlined"
                height="37px"
                width="116px"
                onClick={handleSave}
                disabled={groupValue === ''}
              />
            )}
            <Button
              label={
                isEdit ? messages.UPDATE_BUTTON : messages.ON_BOARDING_BUTTON
              }
              variant="contained"
              height="37px"
              width={isEdit ? '120px' : '197px'}
              onClick={handleStartOnBoarding}
              disabled={groupValue === ''}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AddGroupPopup;
